'use client'

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import Image from 'next/image'
import { useRef } from 'react'
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io'
import Slider, { Settings } from 'react-slick'

import { Separator } from '../../../_components/ui/separator'
import {
  Section,
  SectionColumn,
  SectionContent,
  SectionHeaderSubtitle,
  SectionHeaderTitle,
  SectionRow,
  SectionText,
} from '../_components/section'
import { TESTIMONIALS } from '../_constants/testimonies'

const settings: Settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
}

const TestimoniesMobile = () => {
  const customSlider = useRef<Slider | null>(null)

  const handleNextSlide = () => customSlider.current?.slickNext()

  const handlePreviousSlide = () => customSlider.current?.slickPrev()

  return (
    <Section className="sm:hidden" id="testimonies-mobile">
      <SectionContent className="w-full pb-10 pt-5">
        <SectionColumn className="w-full items-center gap-4 self-stretch text-center">
          <SectionHeaderSubtitle>O que dizem sobre nós</SectionHeaderSubtitle>
          <SectionHeaderTitle className="w-60">
            O que dizem sobre a Doutor Sim
          </SectionHeaderTitle>
        </SectionColumn>

        <Slider
          {...settings}
          ref={(slider) => (customSlider.current = slider) as any}
        >
          {TESTIMONIALS.map((testimonial) => (
            <SectionColumn
              className="w-full flex-shrink-0 items-start gap-6 rounded-2xl border border-solid border-brand-grayscale-3 px-8 py-10"
              key={testimonial.id}
            >
              <Image
                src="/icons/double-quotes.svg"
                width={35}
                height={27}
                alt="Aspas"
              />

              <SectionText>{testimonial.message}</SectionText>

              <SectionColumn className="text-xs">
                <span className="font-bold">Procedimento</span>
                <SectionText>{testimonial.procedure}</SectionText>
              </SectionColumn>

              <Separator className="bg-brand-grayscale-3 sm:hidden" />

              <SectionColumn className="text-xs">
                <span className="font-bold">{testimonial.name}</span>
                <SectionText>{testimonial.occupation}</SectionText>
              </SectionColumn>
            </SectionColumn>
          ))}
        </Slider>

        <SectionRow className="gap-5 self-center text-2xl text-brand-green-primary-5">
          <button
            className="rounded-full border border-solid border-brand-grayscale-3 p-4"
            onClick={handlePreviousSlide}
          >
            <IoIosArrowBack />
          </button>
          <button
            className="rounded-full border border-solid border-brand-grayscale-3 p-4"
            onClick={handleNextSlide}
          >
            <IoIosArrowForward />
          </button>
        </SectionRow>
      </SectionContent>
    </Section>
  )
}

export default TestimoniesMobile
